import { withInstall } from '../../utils/install';
import SvgLoader from './index.vue';

export const IvueSvgLoader = withInstall(SvgLoader);
export default IvueSvgLoader;

export * from './index.vue';
